import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {uniqBy} from 'lodash/fp';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {GetFarmsAction, userDetailAction} from '../action';

function* execute({payload: {breederId}}: GetFarmsAction): SagaIterator {
    yield* put(userDetailAction.setLoading('getFarms', true));

    const response = yield* call(Api.findAllFarmsByBreederId, {breederId});

    if (response.isSuccess) {
        yield* put(userDetailAction.setFarms(uniqBy('id', response.data)));
    } else {
        yield putAll(showBeError(response, t('userDetail')('farmOptionsLoading')));
    }

    yield* put(userDetailAction.setLoading('getFarms', false));
}

export function* getFarmsSaga(): SagaIterator {
    yield takeLatestF('userDetail/GET_FARMS', execute);
}
